module.exports = __webpack_public_path__ + "static/media/seatedEvents.90d45a58.svg";